module.exports = "<section class=\"head\">\n    <div class=\"container\">\n        <div class=\"head-image\">\n        </div>\n    </div>\n</section>\n"